import React, { useEffect, useState } from 'react'
import { OperationReportClustorDetails,ClustorDetailsSummary, ClustorHeadSummary } from '../../../app/models/Restoration';
import { Button, Dropdown, DropdownItemProps, Form, Header, Icon, Loader, Table, TableBody, TableCell, TableFooter, TableHeaderCell, TableRow, Input } from 'semantic-ui-react';
import {useStore} from '../../../app/stores/store';
import { toast } from 'react-toastify';
const ClusterWiseOperationalReport = () => {
  const { RestorationStore } = useStore();
  const [loadData,setLoadData]=useState<OperationReportClustorDetails[]>([]);
  const [clusterSummary,setClusterSummary]=useState<ClustorDetailsSummary[]>([]);
  const [clustorHeadSummary,setClustorHeadSummary]=useState<ClustorHeadSummary[]>([]);
  const [year, setyear] = useState<string>('');
  const [month, setmonth] = useState<string>('');
  const [laoding,setLoading]=useState<boolean>(false);
  const [visibleCluster, setVisibleCluster] = useState(null);
  const [visibleHead, setVisibleHead] = useState(null);
  const [downloadHandleChecked , setDownloadHandleChecked]=useState<string>('');
  const [checkedAllCluster,setCheckedAllCluster]=useState<boolean>(false);
  const [checkedManagerSummary,setCheckedManagerSummary]=useState<boolean>(false);
  const [checkedClusterSummary,setCheckedClusterSummary]=useState<boolean>(false);
  const [years, setYears] = useState<DropdownItemProps[]>([]);
  const [reportType, setReportType] = useState<string>('');
  const [fromDate, setFromDate] = useState<string>('');
  const [toDate, setToDate] = useState<string>('');
  const [employeeId, setEmployeeId] = useState<string>('');

  const handleButtonClick = (clusterName: any) => {
    setVisibleCluster(visibleCluster === clusterName ? null : clusterName);
  };
  const handleHeadClick = (HeadName: any) => {
    setVisibleHead(visibleHead === HeadName ? null : HeadName);
  };
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYears([
      { key: currentYear - 1, value: currentYear - 1, text: (currentYear - 1).toString() },
      { key: currentYear, value: currentYear, text: currentYear.toString() },
      { key: currentYear + 1, value: currentYear + 1, text: (currentYear + 1).toString() },
    ]);
  }, []);

  useEffect(() => {
      setFromDate('');
      setToDate('');
      setEmployeeId('');
      setmonth('');
      setyear('');
    }, [reportType]);

  const reportTypeOptions = [
      { key: 'monthly', text: 'Monthly-wise', value: 'monthly' },
      { key: 'datewise', text: 'Date-wise', value: 'datewise' },
    ];
   const ListOfMonth = [
    { key: 1, text: 'January', value: 'January' },
    { key: 2, text: 'February', value: 'February' },
    { key: 3, text: 'March', value: 'March'},
    { key: 4, text: 'April', value: 'April' },
    { key: 5, text: 'May', value: 'May' },
    { key: 6, text: 'June', value: 'June' },
    { key: 7, text: 'July', value: 'July' },
    { key: 8, text: 'August', value: 'August' },
    { key: 9, text: 'September', value: 'September' },
    { key: 10, text: 'October', value: 'October' },
    { key: 11, text: 'November', value: 'November' },
    { key: 12, text: 'December', value: 'December' },
  ]
  const handleMonthChange = (event:any, data:any) => {
    setmonth(data.value);
  };
  const handleYearChange = (event:any, data:any) => {
    setyear(data.value);
  };
  useEffect(() => {
    if (loadData.length > 0) {
      const uniqueClusterNames = Array.from(new Set(loadData.map(data => data.clusterName)));
      const summary = uniqueClusterNames.map(uniqueClusterName => {
        const clusterData = loadData.filter(x => x.clusterName === uniqueClusterName);
        const head=clusterData[0].headName;
        const titleCount = clusterData.length;
        const estimateHour = clusterData.reduce((sum, x) => sum + x.estimateHour, 0);
        const actualHour = clusterData.reduce((sum, x) => sum + x.actualHour, 0);
        const qcRejectFrameSummary = clusterData.reduce((sum, x) => sum + x.qcRejectFrame, 0);
        const qaRejectFrameSummary = clusterData.reduce((sum, x) => sum + x.qaRejectFrame, 0);
        const totalFrame = clusterData.reduce((sum, x) => sum + x.totalFrame, 0);

        return {
          headName:head,
          clusterName: uniqueClusterName,
          titleCount,
          estimateHour,
          actualHour,
          qcRejectFrameSummary,
          qaRejectFrameSummary,
          totalFrame
        };
      });
      setClusterSummary(summary);

      const HeadName = Array.from(new Set(loadData.map(data => data.headName)));
      const Headsummary = HeadName.map(Head => {
        const clusterData = loadData.filter(x => x.headName === Head);
        const titleCount = clusterData.length;
        const estimateHour = clusterData.reduce((sum, x) => sum + x.estimateHour, 0);
        const actualHour = clusterData.reduce((sum, x) => sum + x.actualHour, 0);
        const qcRejectFrameSummary = clusterData.reduce((sum, x) => sum + x.qcRejectFrame, 0);
        const qaRejectFrameSummary = clusterData.reduce((sum, x) => sum + x.qaRejectFrame, 0);
        const totalFrame = clusterData.reduce((sum, x) => sum + x.totalFrame, 0);
        
        return {
          headName: Head,
          titleCount,
          estimateHour,
          actualHour,
          qcRejectFrameSummary,
          qaRejectFrameSummary,
          totalFrame
        };
      });
      setClustorHeadSummary(Headsummary);
      setLoading(false);
    }
  }, [loadData]);

  const getHeadTotal = (property: keyof ClustorHeadSummary): number => {
    return clustorHeadSummary.reduce((total, item) => total + Number(item[property]), 0);
  };
 

const apiCall= async ()=>{
  try {
  setLoading(true);
  await RestorationStore.ClusterOperationReportAPICall(month,year, fromDate, toDate);
  await setLoadData(RestorationStore.OperationReportClustorDetails);}
  catch (error) {toast.error('Error fetching data');}}

  const ReportHandle=( ReportType:string)=>{
    if(ReportType==='AllCluster')
      {
      setCheckedClusterSummary(false);
      setCheckedAllCluster(true);
      setCheckedManagerSummary(false);
      setDownloadHandleChecked('AllCluster');
    }
    if(ReportType==='ManagerSummary')
      {
      setCheckedClusterSummary(false);
      setCheckedAllCluster(false);
      setCheckedManagerSummary(true);
      setDownloadHandleChecked('ManagerSummary');
    }
    if(ReportType==='ClusterSummary')
      {
      setCheckedClusterSummary(true);
      setCheckedAllCluster(false);
      setCheckedManagerSummary(false);
      setDownloadHandleChecked('ClusterSummary');
    }

  }

  const CsvConvert=()=>{
   
    const rows=[];
    const AllClusterHeaderNames = [
      'Head Name',
      'Cluster Name',
      'Title Name',
      'Title Code',
      'Resolution With FPS',
      'Estimated Hours',
      'Actual hours',
      'Recd Date',
      'Start Date',
      'Schedule Date',
      'End Date',
      'TAT',
      'Total Frames',
      'QC Rejected Frames',
      'QA Rejected Frames',
  ];
  const ManagerSummaryHeaderNames = [
    'Head Name',
    'Title Count',
    'Estimated Hours',
    'Actual hours',
    'QC Reject Frame',
    'QA Reject Frame',
    'Total Frames',
];
const ClusterSummarySummaryHeaderNames = [
  'Head Name',
  'Cluster Name',
  'Title Count',
  'Estimated Hours',
  'Actual hours',
  'QC Reject Frame',
  'QA Reject Frame',
  'Total Frames',
];
if(downloadHandleChecked==='' ){
  toast.error("Please Select Any One Download Options")
}
if(downloadHandleChecked==='AllCluster' )
  {
    rows.push(AllClusterHeaderNames.join(','));
    loadData.forEach((item:any)=>{
    const values = Object.values(item);
    rows.push(values.join(','));
    });}
  if(downloadHandleChecked==='ManagerSummary' ){
    rows.push(ManagerSummaryHeaderNames.join(','));
    clustorHeadSummary.forEach((Manageritems:any)=>{
      const values = Object.values(Manageritems);
            rows.push(values.join(','));
    });}
    if(downloadHandleChecked==='ClusterSummary' ){
      rows.push(ClusterSummarySummaryHeaderNames.join(','));
      clusterSummary.forEach((items:any)=>{
        const values = Object.values(items);
              rows.push(values.join(','));
      });}
    const csvContent = rows.join('\n');
    return csvContent;
  }

  const handleDownload = () => {
    const csvContent = CsvConvert();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${month}_${year}_${downloadHandleChecked}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

  return (
    <>
    <div className="title-wise-table" >
    <div>
      <Header as="h2" >Cluster Wise Operational Report </Header>
      </div>
      <br/>

    <div style={{ display: 'flex', alignItems: 'center' }}>

      <Form.Field>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ paddingLeft: '20px' }}>
                <h4>Report Type:</h4>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <Dropdown
                  placeholder="Select Type"
                  selection
                  clearable
                  options={reportTypeOptions}
                  onChange={(e, data) => setReportType(data.value as string)}
                  value={reportType}
                />
              </div>

              {reportType === 'monthly' && (
                <>
                  <div style={{ paddingLeft: '20px' }}>
                    <h4>Year:</h4>
                  </div>
                  <div style={{ paddingLeft: '20px' }}>
                    <Dropdown
                      placeholder="Year"
                      search
                      selection
                      options={years}
                      onChange={handleYearChange}
                      value={year}
                    />
                  </div>
                  <div style={{ paddingLeft: '20px' }}>
                    <h4>Month:</h4>
                  </div>
                  <div style={{ paddingLeft: '20px' }}>
                    <Dropdown
                      placeholder="Month"
                      search
                      selection
                      options={ListOfMonth}
                      onChange={handleMonthChange}
                      value={month}
                    />
                  </div>
                </>
              )}

              {reportType === 'datewise' && (
                <>
                  <div style={{ paddingLeft: '20px' }}>
                    <h4>From:</h4>
                  </div>
                  <div style={{ paddingLeft: '10px' }}>
                    <Input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                  <div style={{ paddingLeft: '20px' }}>
                    <h4>To:</h4>
                  </div>
                  <div style={{ paddingLeft: '10px' }}>
                    <Input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </>
              )}
            </div>
          </Form.Field>

          {((year && month) || (fromDate && toDate)) && (
            <>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '20px',
                }}
              >
                <Button primary onClick={apiCall}>
                  View Report
                </Button>
              </div>                                                                                                                                                  oratio
            </>
          )}
            <Form.Field></Form.Field>
          {/* <Form.Field>
          <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <h4> Year : {'  '} </h4> 
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <Dropdown
                    placeholder='Year'
                    search
                    selection
                    options={years}
                    onChange={handleYearChange}
                    value={year}
                  />
                  
                    </div></div>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <h4> Month : {'  '} </h4>  </div>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <Dropdown
                      placeholder='Month'
                      search
                      selection
                      options={ListOfMonth}
                      onChange={handleMonthChange}
                      value={month}
                    /></div>
                    
                    {month && year &&(
                      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                    <Button primary onClick={ apiCall}>View Report</Button></div>)}
          </div>
          </Form.Field> */}
          <Form.Field>
          {loadData.length !== 0 && (
          <Header style={{marginLeft:'10px'}} as="h4">Download Options:</Header>)}
          </Form.Field>
          <Form.Field>
          {loadData.length !== 0 && (
                <div className="ui checked checkbox" style={{marginLeft:'10px'}}>
                <input type="checkbox" onClick={()=>ReportHandle('AllCluster')} checked={checkedAllCluster}/>
                <label>All Cluster</label> 
                </div>)}
          </Form.Field>
          <Form.Field>
          {loadData.length !== 0 && (
                <div className="ui checked checkbox" >
                <input type="checkbox" onClick={()=>ReportHandle('ClusterSummary')} checked={checkedClusterSummary}/>
                <label>Cluster Summary</label>
                </div>)}
          </Form.Field>
          <Form.Field>
          {
                loadData.length !== 0 && (
                <div className="ui checked checkbox" >
                <input type="checkbox" onClick={()=>ReportHandle('ManagerSummary')} checked={checkedManagerSummary}/>
                <label>Manager Summary</label>
                </div>)
          }
          </Form.Field> 
          <Form.Field>
                  <div style={{ display: 'flex', alignItems: 'center'}}>{loadData.length !== 0 && (<Button onClick={handleDownload}><Icon className='download'/></Button>)}</div>
          </Form.Field>
        </div>
        
        <br/>
        { laoding ? <div><br/><Loader active inline='centered' > Please wait, this will take a few minutes... </Loader></div>: 
    <div>
<div>

      <Table>
        <Table.Header>
        <TableHeaderCell>Head Name</TableHeaderCell>
        <TableHeaderCell>Title Count</TableHeaderCell>
        <TableHeaderCell>Estimate Hour</TableHeaderCell>
        <TableHeaderCell>Actual Hour</TableHeaderCell>
        <TableHeaderCell>Total Frame</TableHeaderCell>
        <TableHeaderCell>QC Reject Frame Summary</TableHeaderCell>
        <TableHeaderCell>QA Reject Frame Summary</TableHeaderCell>
        <TableHeaderCell>Break Up</TableHeaderCell>
        </Table.Header>
        <TableBody>
                        {clustorHeadSummary.length === 0 && (
                          <Table.Row>
                            <Table.Cell colSpan={8} textAlign="center">
                              Currently Data not Available
                            </Table.Cell>
                          </Table.Row>)}
                          {clustorHeadSummary.map((head,index)=>(<React.Fragment key={index}>
                              <TableRow>
                              <TableCell>{head.headName}</TableCell>
                              <TableCell>{head.titleCount}</TableCell>
                              <TableCell>{head.estimateHour}</TableCell>
                              <TableCell>{head.actualHour}</TableCell>
                              <TableCell>{head.totalFrame}</TableCell>
                              <TableCell>{head.qcRejectFrameSummary}</TableCell>
                              <TableCell>{head.qaRejectFrameSummary}</TableCell>
                              <TableCell>
                                <Button className='ui basic buttonui small basic icon buttons' onClick={() => handleHeadClick(head.headName)}>
                                  <Icon className={visibleHead===head.headName ? 'minus square outline' : 'plus square outline' }/>
                                </Button>
                              </TableCell>
                              </TableRow>
                              {visibleHead === head.headName && (
                              <TableRow>
                                <TableCell colspan={8}>
                                <Table>
                                <Table.Header>
                                  <Table.Row>
                                    <TableHeaderCell>Cluster Name</TableHeaderCell>
                                    <TableHeaderCell>Title Count</TableHeaderCell>
                                    <TableHeaderCell>Estimate Hour</TableHeaderCell>
                                    <TableHeaderCell>Actual Hour</TableHeaderCell>
                                    <TableHeaderCell>Total Frame</TableHeaderCell>
                                    <TableHeaderCell>QC Reject Frame Summary</TableHeaderCell>
                                    <TableHeaderCell>QA Reject Frame Summary</TableHeaderCell>
                                    <TableHeaderCell>Break Up</TableHeaderCell>
                                  </Table.Row>
                                </Table.Header>
                                <TableBody>
                                {clusterSummary.filter(x=>x.headName===head.headName).length === 0 && (
                                    <Table.Row>
                                      <Table.Cell colSpan={8} textAlign="center">
                                        Currently Data not Available
                                      </Table.Cell>
                                    </Table.Row>
                                  )}
                                  {clusterSummary.filter(x=>x.headName===head.headName).map((item, index) => (
                            <React.Fragment key={index}>
                            <Table.Row>
                              <Table.Cell>{item.clusterName}</Table.Cell>
                              <Table.Cell>{item.titleCount}</Table.Cell>
                              <Table.Cell>{item.estimateHour}</Table.Cell>
                              <Table.Cell>{item.actualHour}</Table.Cell>
                              <Table.Cell>{item.totalFrame}</Table.Cell>
                              <Table.Cell>{item.qcRejectFrameSummary}</Table.Cell>
                              <Table.Cell>{item.qaRejectFrameSummary}</Table.Cell>
                              <Table.Cell>
                                <Button className='ui basic buttonui small basic icon buttons' onClick={() => handleButtonClick(item.clusterName)}>
                                  <Icon className={visibleCluster===item.clusterName ? 'minus square outline' : 'plus square outline' }/>
                                </Button>
                              </Table.Cell>
                            </Table.Row>
                            {visibleCluster === item.clusterName && (
                              <Table.Row>
                                <Table.Cell colSpan={8}>
                                  <Table>
                                    <Table.Header>
                                      <Table.Row>
                                        <TableHeaderCell>Title Name</TableHeaderCell>
                                        <TableHeaderCell>Title Code</TableHeaderCell>
                                        <TableHeaderCell>Resolution With FPS</TableHeaderCell>
                                        <TableHeaderCell>Estimated Hour</TableHeaderCell>
                                        <TableHeaderCell>Actual Hour</TableHeaderCell>
                                        <TableHeaderCell>Recd Date</TableHeaderCell>
                                        <TableHeaderCell>Start Date</TableHeaderCell>
                                        <TableHeaderCell>Schedule Date</TableHeaderCell>
                                        <TableHeaderCell>End Date</TableHeaderCell>
                                        <TableHeaderCell>TAT</TableHeaderCell>
                                        <TableHeaderCell>Total Frame</TableHeaderCell>
                                        <TableHeaderCell>QC Reject Frame</TableHeaderCell>
                                        <TableHeaderCell>QA Reject Frame</TableHeaderCell>
                                      </Table.Row>
                                    </Table.Header>
                                    <TableBody>
                                      {loadData.filter(x => x.clusterName === item.clusterName).length === 0 && (
                                        <Table.Row>
                                          <Table.Cell colSpan={8} textAlign="center">
                                            Currently Data not Available
                                          </Table.Cell>
                                        </Table.Row>
                                      )}
                                      {loadData.filter(x => x.clusterName === item.clusterName).map((data, index) => (
                                        <Table.Row key={index}>
                                          <Table.Cell>{data.titleName}</Table.Cell>
                                          <Table.Cell>{data.titleCode}</Table.Cell>
                                          <Table.Cell>{data.resolutionWithFPS}</Table.Cell>
                                          <Table.Cell>{data.estimateHour}</Table.Cell>
                                          <Table.Cell>{data.actualHour}</Table.Cell>
                                          <Table.Cell>{data.recdDate}</Table.Cell>
                                          <Table.Cell>{data.startDate}</Table.Cell>
                                          <Table.Cell>{data.scheduleDate}</Table.Cell>
                                          <Table.Cell>{data.endDate}</Table.Cell>
                                          <Table.Cell>{data.tat}</Table.Cell>
                                          <Table.Cell>{data.totalFrame}</Table.Cell>
                                          <Table.Cell>{data.qcRejectFrame}</Table.Cell>
                                          <Table.Cell>{data.qaRejectFrame}</Table.Cell>
                                        </Table.Row>
                                      ))}
                                    </TableBody>

                                  </Table>
                                </Table.Cell>
                              </Table.Row>
                            )}
                          </React.Fragment>
                                  ))}
                                </TableBody>
                                
                                </Table>
                                </TableCell>
                              </TableRow>) }
          </React.Fragment>))}
        </TableBody>
        {clustorHeadSummary.length!== 0 &&(
          <TableFooter>
              <TableRow>
              <TableHeaderCell style={{ fontWeight: 'bold' }}> Grand Total</TableHeaderCell>
            <TableHeaderCell style={{ fontWeight: 'bold' }}> {getHeadTotal('titleCount')}</TableHeaderCell>
            <TableHeaderCell style={{ fontWeight: 'bold' }}> {getHeadTotal('estimateHour')}</TableHeaderCell>
            <TableHeaderCell style={{ fontWeight: 'bold' }}> {getHeadTotal('actualHour')}</TableHeaderCell>
            <TableHeaderCell style={{ fontWeight: 'bold' }}> {getHeadTotal('totalFrame')}</TableHeaderCell>
            <TableHeaderCell style={{ fontWeight: 'bold' }}> {getHeadTotal('qcRejectFrameSummary')}</TableHeaderCell>
            <TableHeaderCell style={{ fontWeight: 'bold' }} colSpan={2}> {getHeadTotal('qaRejectFrameSummary')}</TableHeaderCell>
              </TableRow>
              </TableFooter>
        )}
        
      </Table>
</div>
    </div>
    }
    </div> 
    </>
    
  )
}

export default ClusterWiseOperationalReport